import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pref-center',
  templateUrl: './pref-center.component.html',
  styleUrls: ['./pref-center.component.sass']
})
export class PrefCenterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    let serverDate = this.formatDate(new Date());
    let serverTime = this.getUTCTime(new Date());
    window["pageData"].page={
      'name': 'Preference Center',
      'serverDate': serverDate,
      'serverTime': serverTime,
      'storefrontName': 'retail',
      'htmlPageTitle': document.title
    };
  }

  formatDate(date) {
    var day = date.getUTCDate();
    var monthIndex = date.getUTCMonth();
    var year = date.getUTCFullYear();
  
    return [monthIndex +1] + '/' + day + '/' + year;
  }

   getUTCTime(date) {
    var hours = date.getUTCHours();
    var minutes = date.getUTCMinutes();
    var seconds = date.getUTCSeconds();
    var ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0'+minutes : minutes;
    var strTime = hours + ':' + minutes + ':' + seconds +' ' + ampm;
    return strTime;
  }

}
